module.exports = __webpack_public_path__ + "img/reference70.ad2a1717.jpg";